module.exports = __webpack_public_path__ + "static/media/BESTS_darker.57d61e5b.webp";